import DodonesListItem from 'app/dodones/list/Item'

export default ({
  dodones,
  ListItemElement,
  scroll = true,
  ...listItemProps
}) => {
  const ListItem = ListItemElement || DodonesListItem

  if (dodones.length == 0) return null

  return (
    <div
      className="fcol flex-1"
      style={{ overflowY: scroll ? 'scroll' : 'none' }}
    >
      <div className="fcol flex-1">
        {Object.entries(dodones).map(([index, dodone]) => {
          return <ListItem key={index} dodone={dodone} {...listItemProps} />
        })}
      </div>
    </div>
  )
}
